var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',[_c('h1',[_vm._v(_vm._s(_vm.$t("utilityComponents.notAvailable.websiteUnavailable")))]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',[_vm._v(_vm._s(_vm.$t("utilityComponents.notAvailable.sorryMessage")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }